import { render, staticRenderFns } from "./ExportBtn.vue?vue&type=template&id=032c009a&scoped=true"
import script from "./ExportBtn.vue?vue&type=script&lang=js"
export * from "./ExportBtn.vue?vue&type=script&lang=js"
import style0 from "./ExportBtn.vue?vue&type=style&index=0&id=032c009a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032c009a",
  null
  
)

export default component.exports